/**
 * Bundy Bundle Dual-Product Customizer
 * =====================================
 * Handles the dual-engraving flow for the Bundy Bundle product.
 * This is completely separate from the standard customizer and
 * does NOT interfere with any other product's engraving.
 *
 * Products: Bottle (1L or 4L) + Drink Cooler
 * Engraving: Front only for each product
 */

$(document).ready(function () {
  // Only run on Bundy Bundle product page
  if (!$(".popup_bundy_customizer")[0]) return;

  // State management for both products
  var bundyState = {
    activeTab: "bottle", // 'bottle' or 'cooler'
    bottle: {
      text: "",
      font: "Roboto",
      logoUrl: "",
      logoName: "",
      type: "" // 'text', 'logo', or ''
    },
    cooler: {
      text: "",
      font: "Roboto",
      logoUrl: "",
      logoName: "",
      type: "" // 'text', 'logo', or ''
    }
  };
  var FONT_CLASSES = "font-Roboto font-Manderley font-Crosterian font-Whiphand font-Socialist";

  // ==========================================
  // OPEN CUSTOMIZER
  // ==========================================
  $(document).on("click", ".customise_button", function () {
    // Only intercept for Bundy Bundle
    if (!$(".popup_bundy_customizer")[0]) return;

    // Hide the standard customizer if it exists
    $(".popup_pd_customizer").removeClass("active");

    // Reset state
    bundyState.bottle = { text: "", font: "Roboto", logoUrl: "", logoName: "", type: "" };
    bundyState.cooler = { text: "", font: "Roboto", logoUrl: "", logoName: "", type: "" };
    bundyState.activeTab = "bottle";

    // Reset UI
    resetBundyUI();

    // Update variant images based on current selection
    updateBundyVariantImages();

    // Apply texture to text overlays on open
    var selectedOption = $(".bundy_size_select option:selected");
    var variantId = selectedOption.val();
    var variantData = $(".bundy_variant_data[data-variant-id='" + variantId + "']");
    if (variantData.length) {
      var textureUrl = variantData.attr("data-texture");
      if (textureUrl) {
        $(".bundy_textup").css("background-image", 'url("' + textureUrl + '")');
      }
    }

    // Show the Bundy customizer
    $("body").addClass("bundy_customizer_active");
    $(".popup_bundy_customizer").addClass("active");
  });

  // ==========================================
  // CLOSE CUSTOMIZER
  // ==========================================
  $(document).on("click", ".bundy_close_btn", function () {
    $(".popup_bundy_customizer").removeClass("active");
    $("body").removeClass("bundy_customizer_active");
  });

  // ==========================================
  // TAB SWITCHING
  // ==========================================
  $(document).on("click", ".bundy_tab_bottle", function () {
    saveCurrentTabState();
    bundyState.activeTab = "bottle";
    $(".bundy_tab").removeClass("active");
    $(this).addClass("active");
    $(".bundy_bottle_preview").addClass("active");
    $(".bundy_cooler_preview").removeClass("active");
    restoreTabState("bottle");
    goToSelectionMenu();
  });

  $(document).on("click", ".bundy_tab_cooler", function () {
    saveCurrentTabState();
    bundyState.activeTab = "cooler";
    $(".bundy_tab").removeClass("active");
    $(this).addClass("active");
    $(".bundy_cooler_preview").addClass("active");
    $(".bundy_bottle_preview").removeClass("active");
    restoreTabState("cooler");
    goToSelectionMenu();
  });

  // ==========================================
  // VARIANT SIZE SELECTOR
  // ==========================================
  $(document).on("change", ".bundy_size_select", function () {
    updateBundyVariantImages();
    // Also update the main product page variant selector
    var selectedOption = $(this).find("option:selected");
    var variantTitle = selectedOption.text().trim();
    var mainSelect = $("#ProductSelect-option-1");
    if (mainSelect.length) {
      mainSelect.val(variantTitle);
      mainSelect[0].dispatchEvent(new Event("change", { bubbles: true }));
    }
  });

  // ==========================================
  // TEXT OPTION
  // ==========================================
  $(document).on("click", ".bundy_text_option", function () {
    $(".bundy_selection_menu").addClass("hide");
    $(".bundy_text_section").removeClass("hide");
    $(".bundy_logo_section").addClass("hide");

    // Restore any existing text for this tab
    var state = bundyState[bundyState.activeTab];
    if (state.type === "text" && state.text) {
      $(".bundy_text_input").val(state.text);
      var fontClass = "font-" + state.font;
      $(".bundy_text_input").removeClass(FONT_CLASSES).addClass(fontClass);
      $(".bundy_font_item").removeClass("active");
      $(".bundy_font_item[data-font='" + state.font + "']").addClass("active");
      $(".bundy_preview_text").removeAttr("disabled");
    } else {
      $(".bundy_text_input").val("");
      $(".bundy_text_input").removeClass(FONT_CLASSES).addClass("font-Roboto");
      $(".bundy_font_item").removeClass("active");
      $(".bundy_font_item[data-font='Roboto']").addClass("active");
      $(".bundy_preview_text").attr("disabled", "disabled");
    }
  });

  // Text input handling
  var RE_EMOJI = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
  var RE_SPECIAL = /[^a-zA-Z0-9\s]/g;

  $(document).on("keyup keydown change paste input", ".bundy_text_input", function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
      return false;
    }

    var $elem = $(this);
    var content = $elem.val();

    // Remove emojis and special characters
    if (RE_EMOJI.test(content) || RE_SPECIAL.test(content)) {
      content = content.replace(RE_EMOJI, "").replace(RE_SPECIAL, "");
      $elem.val(content);
    }

    var valLength = content.length;
    var maxSize = parseInt($elem.attr("data-size")) || 10;

    if (valLength > maxSize) {
      $(".bundy_char_warning").removeClass("hide");
      $(".bundy_preview_text").attr("disabled", "disabled");
    } else {
      $(".bundy_char_warning").addClass("hide");
      if (valLength > 0) {
        $(".bundy_preview_text").removeAttr("disabled");
      } else {
        $(".bundy_preview_text").attr("disabled", "disabled");
      }
    }

    // Update preview on active product
    updateActivePreviewText(content);
  });

  // Font selection
  $(document).on("click", ".bundy_font_item", function () {
    $(".bundy_font_item").removeClass("active");
    $(this).addClass("active");
    var font = $(this).attr("data-font");
    $(".bundy_text_input").removeClass(FONT_CLASSES).addClass("font-" + font);

    // Update preview font
    var activePreview = bundyState.activeTab === "bottle" ? ".bundy_bottle_preview" : ".bundy_cooler_preview";
    $(activePreview + " .bundy_textup").removeClass(FONT_CLASSES).addClass("font-" + font);
  });

  // Text preview/review button
  $(document).on("click", ".bundy_preview_text", function () {
    var text = $(".bundy_text_input").val().trim();
    var font = $(".bundy_font_item.active").attr("data-font");

    // Save to state
    bundyState[bundyState.activeTab].text = text;
    bundyState[bundyState.activeTab].font = font;
    bundyState[bundyState.activeTab].logoUrl = "";
    bundyState[bundyState.activeTab].logoName = "";
    bundyState[bundyState.activeTab].type = "text";

    // Update preview
    updateActivePreviewText(text);
    var activePreview = bundyState.activeTab === "bottle" ? ".bundy_bottle_preview" : ".bundy_cooler_preview";
    $(activePreview + " .bundy_textup").removeClass(FONT_CLASSES).addClass("font-" + font);

    // Show add-to-cart section if both products have customization OR show prompt
    checkAndShowReview();
  });

  // Clear text
  $(document).on("click", ".bundy_clear_text", function () {
    $(".bundy_text_input").val("");
    $(".bundy_preview_text").attr("disabled", "disabled");
    bundyState[bundyState.activeTab].text = "";
    bundyState[bundyState.activeTab].type = "";

    var activePreview = bundyState.activeTab === "bottle" ? ".bundy_bottle_preview" : ".bundy_cooler_preview";
    $(activePreview + " .bundy_text_overlay").addClass("hide");
    $(activePreview + " .bundy_textup").html("");
    $(activePreview + " .bundy_logo_overlay").addClass("hide");
  });

  // ==========================================
  // LOGO OPTION
  // ==========================================
  $(document).on("click", ".bundy_logo_option", function () {
    $(".bundy_selection_menu").addClass("hide");
    $(".bundy_logo_section").removeClass("hide");
    $(".bundy_text_section").addClass("hide");
  });

  // Logo search
  $(document).on("keyup", ".bundy_search_input", function () {
    var query = $(this).val().toLowerCase();
    $(".bundy_logo_item").each(function () {
      var name = $(this).attr("data-search") || "";
      if (name.indexOf(query) >= 0 || query === "") {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });

  // Logo selection
  $(document).on("click", ".bundy_logo_image", function () {
    $(".bundy_logo_image").removeClass("active");
    $(this).addClass("active");
    $(".bundy_preview_logo").removeAttr("disabled");

    var logoSrc = $(this).attr("data-texture");
    var logoName = $(this).siblings(".bundy_logo_name").text().trim();

    // Update preview on active product
    var activePreview = bundyState.activeTab === "bottle" ? ".bundy_bottle_preview" : ".bundy_cooler_preview";
    $(activePreview + " .bundy_logo_overlay").removeClass("hide");
    $(activePreview + " .bundy_logo_img").attr("src", logoSrc);
    $(activePreview + " .bundy_text_overlay").addClass("hide");
  });

  // Logo preview/review button
  $(document).on("click", ".bundy_preview_logo", function () {
    var activeLogo = $(".bundy_logo_image.active");
    if (!activeLogo.length) return;

    var logoSrc = activeLogo.attr("data-texture");
    var logoName = activeLogo.siblings(".bundy_logo_name").text().trim();

    // Save to state
    bundyState[bundyState.activeTab].logoUrl = logoSrc;
    bundyState[bundyState.activeTab].logoName = logoName;
    bundyState[bundyState.activeTab].text = "";
    bundyState[bundyState.activeTab].type = "logo";

    checkAndShowReview();
  });

  // Clear logo
  $(document).on("click", ".bundy_clear_logo", function () {
    $(".bundy_logo_image").removeClass("active");
    $(".bundy_preview_logo").attr("disabled", "disabled");
    bundyState[bundyState.activeTab].logoUrl = "";
    bundyState[bundyState.activeTab].logoName = "";
    bundyState[bundyState.activeTab].type = "";

    var activePreview = bundyState.activeTab === "bottle" ? ".bundy_bottle_preview" : ".bundy_cooler_preview";
    $(activePreview + " .bundy_logo_overlay").addClass("hide");
    $(activePreview + " .bundy_logo_img").attr("src", "");
  });

  // Back buttons
  $(document).on("click", ".bundy_back_btn", function () {
    goToSelectionMenu();
  });

  // ==========================================
  // REVIEW & ADD TO CART
  // ==========================================
  function checkAndShowReview() {
    var bottleHas = bundyState.bottle.type !== "";
    var coolerHas = bundyState.cooler.type !== "";

    // Update review summary
    updateReviewSummary();

    if (bottleHas && coolerHas) {
      // Both products customized - show add to cart
      $(".bundy_addtocart_section").removeClass("hide");
      $(".bundy_customize_section").addClass("hide");
      $(".bundy_tabs").addClass("hide");

      // Show both previews
      $(".bundy_bottle_preview").addClass("active");
      $(".bundy_cooler_preview").addClass("active");
    } else if (bottleHas && !coolerHas) {
      // Bottle done, switch to cooler
      $(".bundy_tab_cooler").trigger("click");
    } else if (!bottleHas && coolerHas) {
      // Cooler done, switch to bottle
      $(".bundy_tab_bottle").trigger("click");
    }
  }

  function updateReviewSummary() {
    // Bottle summary
    if (bundyState.bottle.type === "text") {
      $(".bundy_review_bottle_text").text('"' + bundyState.bottle.text + '" (' + bundyState.bottle.font + ')');
    } else if (bundyState.bottle.type === "logo") {
      $(".bundy_review_bottle_text").text("Design: " + bundyState.bottle.logoName);
    } else {
      $(".bundy_review_bottle_text").text("None");
    }

    // Cooler summary
    if (bundyState.cooler.type === "text") {
      $(".bundy_review_cooler_text").text('"' + bundyState.cooler.text + '" (' + bundyState.cooler.font + ')');
    } else if (bundyState.cooler.type === "logo") {
      $(".bundy_review_cooler_text").text("Design: " + bundyState.cooler.logoName);
    } else {
      $(".bundy_review_cooler_text").text("None");
    }
  }

  // Quantity controls
  $(document).on("click", ".bundy_qty_add", function () {
    var input = $(".bundy_qty_input");
    input.val(parseInt(input.val()) + 1);
  });

  $(document).on("click", ".bundy_qty_sub", function () {
    var input = $(".bundy_qty_input");
    if (parseInt(input.val()) > 1) {
      input.val(parseInt(input.val()) - 1);
    }
  });

  // Add to Cart button
  $(document).on("click", ".bundy_add_to_cart", function () {
    // Show confirmation popup
    var details = "";
    details += "<p><strong>Bottle:</strong> ";
    if (bundyState.bottle.type === "text") {
      details += 'Text: "' + bundyState.bottle.text + '" (Font: ' + bundyState.bottle.font + ")";
    } else if (bundyState.bottle.type === "logo") {
      details += "Design: " + bundyState.bottle.logoName;
    }
    details += "</p>";

    details += "<p><strong>Drink Cooler:</strong> ";
    if (bundyState.cooler.type === "text") {
      details += 'Text: "' + bundyState.cooler.text + '" (Font: ' + bundyState.cooler.font + ")";
    } else if (bundyState.cooler.type === "logo") {
      details += "Design: " + bundyState.cooler.logoName;
    }
    details += "</p>";

    $(".bundy_confirm_details").html(details);
    $(".bundy_confirm_popup").removeClass("hide");
    $(".bundy_addtocart_section").addClass("hide");
  });

  // Confirmation checkbox
  $(document).on("click", ".bundy_chkbox.none", function () {
    $(this).addClass("active").removeClass("none");
    $(".bundy_accept_btn").removeAttr("disabled").addClass("active");
  });

  $(document).on("click", ".bundy_chkbox.active", function () {
    $(this).addClass("none").removeClass("active");
    $(".bundy_accept_btn").attr("disabled", "disabled").removeClass("active");
  });

  // Cancel confirmation
  $(document).on("click", ".bundy_cancel_btn", function () {
    $(".bundy_confirm_popup").addClass("hide");
    $(".bundy_addtocart_section").removeClass("hide");
  });

  // ACCEPT - Submit to cart
  $(document).on("click", ".bundy_accept_btn.active", function (e) {
    e.preventDefault();

    var $btn = $(this);
    $btn.html("Loading....");

    var leftPreviews = $(".bundy_left_previews");
    var pricewithoutcurrency = leftPreviews.attr("data-price");
    var pricemoney = leftPreviews.attr("data-moncurreny");
    var currencyf = leftPreviews.attr("data-cur");
    var product_title = leftPreviews.attr("data-title");
    var qty = parseInt($(".bundy_qty_input").val()) || 1;

    // Get variant ID from the size selector
    var var_id = parseInt($(".bundy_size_select").val());
    var customized_pd = parseInt($(".bundy_data").attr("data-customized-product-id"));

    // Calculate total customization charges
    var customQty = 0;
    if (bundyState.bottle.type !== "") customQty++;
    if (bundyState.cooler.type !== "") customQty++;

    var items = [];

    // Main product
    items.push({
      id: var_id,
      quantity: qty,
      properties: {
        _customised_product: "yes"
      }
    });

    // Customization surcharge with both products' details
    var properties = {
      "_Customised Product": "yes",
      "BUNDLE TYPE": "Dual Engraving"
    };

    addEngravingProperties(properties, "BOTTLE", bundyState.bottle, product_title);
    addEngravingProperties(properties, "COOLER", bundyState.cooler, product_title);

    items.push({
      id: customized_pd,
      quantity: customQty,
      properties: properties
    });

    setTimeout(function () {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: { items: items },
        dataType: "json",
        success: function (response) {
          $(".js-drawer-open-button-right .material-icons-outlined").trigger("click");

          // Close and reset
          $(".popup_bundy_customizer").removeClass("active");
          $("body").removeClass("bundy_customizer_active");
          $btn.html("ACCEPT");
          resetBundyUI();
        },
        error: function () {
          console.error("Error adding Bundy Bundle to cart");
          $btn.html("ACCEPT");
          alert("There was an error adding to cart. Please try again.");
        }
      });
    }, 1000);
  });

  // ==========================================
  // HELPER FUNCTIONS
  // ==========================================
  function addEngravingProperties(properties, prefix, item, title) {
    if (item.type === "text") {
      properties[prefix + " ENGRAVING"] = title;
      properties[prefix + " NAME"] = item.text;
      properties[prefix + " FONT"] = item.font;
    } else if (item.type === "logo") {
      properties[prefix + " ENGRAVING"] = title;
      properties[prefix + " IMAGE"] = item.logoUrl;
      properties[prefix + " GALLERY IMAGE NAME"] = item.logoName;
    }
  }

  function resetBundyUI() {
    // Reset tabs
    $(".bundy_tab").removeClass("active");
    $(".bundy_tab_bottle").addClass("active");
    $(".bundy_bottle_preview").addClass("active");
    $(".bundy_cooler_preview").removeClass("active");

    // Reset sections
    $(".bundy_selection_menu").removeClass("hide");
    $(".bundy_text_section").addClass("hide");
    $(".bundy_logo_section").addClass("hide");
    $(".bundy_addtocart_section").addClass("hide");
    $(".bundy_confirm_popup").addClass("hide");
    $(".bundy_customize_section").removeClass("hide");
    $(".bundy_tabs").removeClass("hide");

    // Reset previews
    $(".bundy_text_overlay").addClass("hide");
    $(".bundy_textup").html("");
    $(".bundy_logo_overlay").addClass("hide");
    $(".bundy_logo_img").attr("src", "");

    // Reset inputs
    $(".bundy_text_input").val("");
    $(".bundy_font_item").removeClass("active");
    $(".bundy_font_item[data-font='Roboto']").addClass("active");
    $(".bundy_logo_image").removeClass("active");
    $(".bundy_search_input").val("");
    $(".bundy_logo_item").show();

    // Reset confirmation
    $(".bundy_chkbox").addClass("none").removeClass("active");
    $(".bundy_accept_btn").attr("disabled", "disabled").removeClass("active");
    $(".bundy_accept_btn").html("ACCEPT");

    // Reset qty
    $(".bundy_qty_input").val(1);
  }

  function goToSelectionMenu() {
    $(".bundy_selection_menu").removeClass("hide");
    $(".bundy_text_section").addClass("hide");
    $(".bundy_logo_section").addClass("hide");
    $(".bundy_logo_image").removeClass("active");
    $(".bundy_search_input").val("");
    $(".bundy_logo_item").show();
  }

  function saveCurrentTabState() {
    // Save any unsaved text input
    if (!$(".bundy_text_section").hasClass("hide")) {
      var text = $(".bundy_text_input").val().trim();
      var font = $(".bundy_font_item.active").attr("data-font");
      if (text) {
        bundyState[bundyState.activeTab].text = text;
        bundyState[bundyState.activeTab].font = font;
        bundyState[bundyState.activeTab].type = "text";
        bundyState[bundyState.activeTab].logoUrl = "";
        bundyState[bundyState.activeTab].logoName = "";
      }
    }
    // Save any unsaved logo selection
    if (!$(".bundy_logo_section").hasClass("hide")) {
      var activeLogo = $(".bundy_logo_image.active");
      if (activeLogo.length) {
        bundyState[bundyState.activeTab].logoUrl = activeLogo.attr("data-texture");
        bundyState[bundyState.activeTab].logoName = activeLogo.siblings(".bundy_logo_name").text().trim();
        bundyState[bundyState.activeTab].type = "logo";
        bundyState[bundyState.activeTab].text = "";
      }
    }
  }

  function restoreTabState(tab) {
    var state = bundyState[tab];
    // Restore preview
    var preview = tab === "bottle" ? ".bundy_bottle_preview" : ".bundy_cooler_preview";

    if (state.type === "text" && state.text) {
      $(preview + " .bundy_text_overlay").removeClass("hide");
      $(preview + " .bundy_textup").html(state.text);
      $(preview + " .bundy_textup").removeClass(FONT_CLASSES).addClass("font-" + state.font);
      $(preview + " .bundy_logo_overlay").addClass("hide");
    } else if (state.type === "logo" && state.logoUrl) {
      $(preview + " .bundy_logo_overlay").removeClass("hide");
      $(preview + " .bundy_logo_img").attr("src", state.logoUrl);
      $(preview + " .bundy_text_overlay").addClass("hide");
    }
  }

  function updateActivePreviewText(text) {
    var activePreview = bundyState.activeTab === "bottle" ? ".bundy_bottle_preview" : ".bundy_cooler_preview";
    if (text) {
      $(activePreview + " .bundy_text_overlay").removeClass("hide");
      $(activePreview + " .bundy_textup").html(text);
      $(activePreview + " .bundy_logo_overlay").addClass("hide");
    } else {
      $(activePreview + " .bundy_text_overlay").addClass("hide");
      $(activePreview + " .bundy_textup").html("");
    }
  }

  function updateBundyVariantImages() {
    var selectedOption = $(".bundy_size_select option:selected");
    var frontSrc = selectedOption.attr("data-front");
    var backSrc = selectedOption.attr("data-back");

    if (frontSrc) {
      $(".bundy_bottle_main_image").attr("src", frontSrc);
    }
    if (backSrc) {
      $(".bundy_cooler_main_image").attr("src", backSrc);
    }

    // Apply texture to text overlays
    var variantId = selectedOption.val();
    var variantData = $(".bundy_variant_data[data-variant-id='" + variantId + "']");
    if (variantData.length) {
      var textureUrl = variantData.attr("data-texture");
      if (textureUrl) {
        $(".bundy_textup").css("background-image", 'url("' + textureUrl + '")');
      }
    }

    // Add size class to bottle preview for CSS positioning
    var variantText = selectedOption.text().trim().toLowerCase();
    var bottlePreview = $(".bundy_bottle_preview");
    bottlePreview.removeClass("bundy_size_4l bundy_size_1l");
    if (variantText.indexOf("1l") !== -1) {
      bottlePreview.addClass("bundy_size_1l");
    } else {
      bottlePreview.addClass("bundy_size_4l");
    }

    // Update variant name display
    $(".bundy_variant_name").text(selectedOption.text().trim());
  }
});

/* ============================================
 * Bundy Bundle Gallery Image Reorder
 * ============================================
 * Reorders the product gallery images based on
 * the selected bottle size (4L or 1L).
 * Uses a MutationObserver to detect when the
 * slider is rebuilt and reorder accordingly.
 */
(function() {
  // Desired image order per bottle size (match by filename substring)
  var orderMap = {
    '4l': [
      'TAP_x_Bundy_Rum_-_Collection_Page_1b_-_WEBP',
      'Bundle-flatlay-BundabergRum-4L',
      '4L-Bottle-BundabergRum-bundle',
      'Stubby-BundabergRum-4L-bundle',
      'Backpack-lifestyle-BundabergRum-4L-bundle'
    ],
    '1l': [
      'TAP_x_Bundy_Rum_-_Collection_Page_1b_-_WEBP',
      'Bundle-flatlay-BundabergRum-1L',
      '1L-Bottle-BundabergRum-bundle',
      'Stubby-BundabergRum-1L-bundle',
      'Backpack-lifestyle-BundabergRum-1L-bundle'
    ]
  };

  function getSelectedSize() {
    var sel = document.querySelector('#ProductSelect-option-1');
    return sel ? sel.value.toLowerCase() : '';
  }

  function reorderSliderImages() {
    var sizeKey = getSelectedSize();
    var order = orderMap[sizeKey];
    if (!order) return;

    var sliderContent = document.querySelector('.slider-content');
    var sliderThumb = document.querySelector('.slider-thumb');
    if (!sliderContent) return;

    // Only act when slick is initialized
    if (!sliderContent.classList.contains('slick-initialized')) return;

    // Get current slides (non-cloned)
    var contentSlides = Array.from(sliderContent.querySelectorAll('.slick-slide:not(.slick-cloned)'));
    if (contentSlides.length === 0) return;

    // Check if already in correct order
    var alreadyOrdered = true;
    for (var i = 0; i < Math.min(order.length, contentSlides.length); i++) {
      var img = contentSlides[i].querySelector('img');
      if (img && img.src.indexOf(order[i]) === -1) {
        alreadyOrdered = false;
        break;
      }
    }
    if (alreadyOrdered) return;

    // Collect slide HTML
    var slideHtmlArr = [];
    contentSlides.forEach(function(slide) {
      var inner = slide.querySelector('.inner_mainmedia');
      if (inner) {
        slideHtmlArr.push({ html: inner.innerHTML, el: inner });
      }
    });

    // Sort by the order map
    var sorted = [];
    var remaining = slideHtmlArr.slice();
    order.forEach(function(name) {
      for (var i = 0; i < remaining.length; i++) {
        if (remaining[i].html.indexOf(name) !== -1) {
          sorted.push(remaining[i]);
          remaining.splice(i, 1);
          break;
        }
      }
    });
    sorted = sorted.concat(remaining);

    // Rebuild HTML
    var newHtml = '';
    sorted.forEach(function(item) {
      newHtml += '<div class="inner_mainmedia">' + item.html + '</div>';
    });

    // Rebuild sliders
    try {
      $('.slider-content').slick('unslick');
      $('.slider-thumb').slick('unslick');
    } catch(e) {}

    sliderContent.innerHTML = newHtml;
    if (sliderThumb) sliderThumb.innerHTML = newHtml;

    try {
      $('.slider-content').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        infinite: false,
        speed: 1000,
        asNavFor: '.slider-thumb'
      });
      $('.slider-thumb').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.slider-content',
        dots: false,
        arrows: true,
        centerMode: false,
        focusOnSelect: true
      });
      $('.slider-thumb')[0].slick.refresh();
    } catch(e) {}
  }

  // Watch for slider initialization/rebuild via MutationObserver
  function setupObserver() {
    var sliderContent = document.querySelector('.slider-content');
    if (!sliderContent) {
      // Retry if slider not yet in DOM
      setTimeout(setupObserver, 500);
      return;
    }

    var observer = new MutationObserver(function(mutations) {
      // Debounce: wait a bit after mutations settle
      clearTimeout(observer._debounce);
      observer._debounce = setTimeout(function() {
        if (sliderContent.classList.contains('slick-initialized')) {
          reorderSliderImages();
        }
      }, 300);
    });

    observer.observe(sliderContent, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    // Also reorder when size dropdown changes
    var sizeSelect = document.querySelector('#ProductSelect-option-1');
    if (sizeSelect) {
      sizeSelect.addEventListener('change', function() {
        // Wait for the slider to be rebuilt by the main script
        setTimeout(reorderSliderImages, 1500);
      });
    }

    // Initial reorder attempt after page scripts run
    setTimeout(reorderSliderImages, 2000);
    setTimeout(reorderSliderImages, 4000);
  }

  // Start observing
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObserver);
  } else {
    setupObserver();
  }
})();

/* ============================================
 * Bundy Bundle "Pick Your Bottle Size" Label
 * ============================================
 * Overrides the "Bottle Size" label text via JS
 * so it works even when the page is served from
 * the CWV Booster cache.
 */
(function() {
  function fixBottleSizeLabel() {
    // Fix the main product label
    var labels = document.querySelectorAll('label[data-option-name="Bottle Size"]');
    labels.forEach(function(label) {
      var span = label.querySelector('.text-sub');
      if (span && label.textContent.indexOf('Pick Your') === -1) {
        label.innerHTML = 'Pick Your Bottle Size: ' + span.outerHTML;
      }
    });

    // Fix the customizer variant_tiles label
    var tiles = document.querySelectorAll('.variant_tiles');
    tiles.forEach(function(tile) {
      if (tile.textContent.trim() === 'Bottle Size') {
        tile.textContent = 'Pick Your Bottle Size';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', fixBottleSizeLabel);
})();
